module.exports = __webpack_public_path__ + "img/form-bg.0962209d.png";